var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighVolume = function SvgHighVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "high-volume_svg__Layer_1",
    width: 20,
    height: 20,
    strokeWidth: 1.5,
    color: "#24053b",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    role: "presentation"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5d3-1{fill:none;stroke:currentColor;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.93 10a2.85 2.85 0 0 1 0 4M18 8a5.72 5.72 0 0 1 0 8.1",
    className: "cls-6374f543b67f094e4896c5d3-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.93a8.57 8.57 0 0 1 0 12.14M1.5 8.18h4.77v7.64H1.5zM13.91 3.41v17.18h-1.67l-5.97-4.77V8.18l5.97-4.77z",
    className: "cls-6374f543b67f094e4896c5d3-1"
  })));
};
export default SvgHighVolume;